import { createApp } from 'vue'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import Aura from '@primevue/themes/aura'
import ConfirmationService from 'primevue/confirmationservice'
import ToastService from 'primevue/toastservice'

import App from './App.vue'
import router from './router'
import i18n, { initLocale } from './i18n'

// Styles
import './app.css'
import 'primeicons/primeicons.css'

// Apply the persisted language before the app mounts (falls back to Spanish).
initLocale()

const app = createApp(App)

// Pinia - State Management
app.use(createPinia())

// vue-i18n - Internationalization (Spanish default, English available)
app.use(i18n)

// Vue Router
app.use(router)

// PrimeVue with Aura theme
app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      prefix: 'p',
      darkModeSelector: '.dark'
    }
  }
})

// PrimeVue Services
app.use(ConfirmationService)
app.use(ToastService)

app.mount('#app')
